import React, { useEffect, useState } from "react";
import ImageType3 from "../../../../components/molecules/image-type-3";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";

const SeriesPageKlipitComponent = ({ klipitStories, isAjaxLoading, behindPaywall, contentType }) => {
  return (
    <div styleName="klipit-items">
      <div styleName="count-sort">
        {isAjaxLoading || klipitStories?.length === 0 ? (
          <p>{isAjaxLoading ? "Ladataan..." : "Klippejä ei löytynyt."}</p>
        ) : (
          <h2 styleName="episodes-count">{`${klipitStories.length} jaksoa`}</h2>
        )}
      </div>

      {klipitStories?.length > 0 &&
        klipitStories.map((item) => (
          <div styleName="item" className="item" key={item.id}>
            <ImageType3
              story={item}
              behindPaywall={behindPaywall}
              contentType={contentType}
              aspectRatio={[[16, 9]]}
            />
          </div>
        ))}
    </div>
  );
};

export default SeriesPageKlipitComponent;
